const imageTextModule = {
  id: "16655df8-f1ed-32fd-a850-40a6f10c5021",
  config: {
    general: {
      template: {
        label: "Top Left",
        component: "ImageTextTopLeft",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      backgroundColor: {
        label: "Nose Green",
        value: "#e2eac9",
      },
    },
    media: {
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cards/card/image/card-image.jpg",
        mediaType: "image",
      },
      mediaAltText: "Awesome image",
      corners: {
        label: "Round",
        value: "round",
      },
    },
    text: {
      text: "We’re change agents and cyber gurus. Performance improvers and problem solvers. Data scientists and growth hackers. Bot programmers and software builders. Risk managers and confidence builders. We’re more than 365,000 global perspectives ready to welcome yours.",
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
  },
};

export default imageTextModule;
